export const isValidRating = (value: number): boolean => {
  return Number.isInteger(value) && value >= 1 && value <= 5;
};
